module.exports = __webpack_public_path__ + "img/c325b06.png";